import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Navigation from "./components/layout/Navigation";
import Footer from "./components/layout/Footer";
import MobileStickyBar from "./components/layout/MobileStickyBar";

import HomePage from "./pages/HomePage";
import GSTRegistrationPage from "./pages/GSTRegistrationPage";
import GSTReturnFilingPage from "./pages/GSTReturnFilingPage";
import EcomGSTRegistrationPage from "./pages/EcomGSTRegistrationPage";
import EcomGSTFilingPage from "./pages/EcomGSTFilingPage";
import ITRFilingPage from "./pages/ITRFilingPage";
import TDSFilingPage from "./pages/TDSFilingPage";
import BusinessRegistrationPage from "./pages/BusinessRegistrationPage";
import BusinessLoanPage from "./pages/BusinessLoanPage";
import PersonalLoanPage from "./pages/PersonalLoanPage";
import EMICalculatorPage from "./pages/EMICalculatorPage";
import GSTPenaltyCalculatorPage from "./pages/GSTPenaltyCalculatorPage";
import GSTInterestCalculatorPage from "./pages/GSTInterestCalculatorPage";
import IncomeTaxCalculatorPage from "./pages/IncomeTaxCalculatorPage";
import TDSPenaltyCalculatorPage from "./pages/TDSPenaltyCalculatorPage";
import LoanEligibilityCalculatorPage from "./pages/LoanEligibilityCalculatorPage";
import ITRChecklistPage from "./pages/ITRChecklistPage";
import GSTNoticeTemplatePage from "./pages/GSTNoticeTemplatePage";
import GSTReconciliationWorksheetPage from "./pages/GSTReconciliationWorksheetPage";
import ComplianceRoadmapPage from "./pages/ComplianceRoadmapPage";
import HealthInsurancePage from "./pages/HealthInsurancePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import AdminPage from "./pages/AdminPage";
import SEOGuidePage from "./pages/SEOGuidePage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const MainLayout = ({ children }) => (
  <div className="App font-body" data-testid="app-container">
    <Navigation />
    <main>{children}</main>
    <Footer />
    <MobileStickyBar />
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <ScrollToTop />
        <MainLayout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/gst-registration" element={<GSTRegistrationPage />} />
            <Route path="/gst-return-filing" element={<GSTReturnFilingPage />} />
            <Route path="/ecom-gst-registration" element={<EcomGSTRegistrationPage />} />
            <Route path="/ecom-gst-filing" element={<EcomGSTFilingPage />} />
            <Route path="/itr-filing" element={<ITRFilingPage />} />
            <Route path="/tds-filing" element={<TDSFilingPage />} />
            <Route path="/business-registration" element={<BusinessRegistrationPage />} />
            <Route path="/business-loan-assistance" element={<BusinessLoanPage />} />
            <Route path="/personal-loan-assistance" element={<PersonalLoanPage />} />
            <Route path="/emi-calculator" element={<EMICalculatorPage />} />
            <Route path="/gst-penalty-calculator" element={<GSTPenaltyCalculatorPage />} />
            <Route path="/gst-interest-calculator" element={<GSTInterestCalculatorPage />} />
            <Route path="/income-tax-calculator" element={<IncomeTaxCalculatorPage />} />
            <Route path="/tds-penalty-calculator" element={<TDSPenaltyCalculatorPage />} />
            <Route path="/loan-eligibility-calculator" element={<LoanEligibilityCalculatorPage />} />
            <Route path="/itr-checklist" element={<ITRChecklistPage />} />
            <Route path="/gst-notice-response-template" element={<GSTNoticeTemplatePage />} />
            <Route path="/gst-reconciliation-worksheet" element={<GSTReconciliationWorksheetPage />} />
            <Route path="/compliance-roadmap" element={<ComplianceRoadmapPage />} />
            <Route path="/health-insurance-advisory" element={<HealthInsurancePage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-service" element={<TermsOfServicePage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/seo-guide" element={<SEOGuidePage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </MainLayout>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
